(function () {
  "use strict";

  function initMenu(root) {
    if (!root || root.dataset.abReady === "true") {
      return;
    }

    root.dataset.abReady = "true";

    var triggers = root.querySelectorAll("[data-ab-target]");
    var panels = root.querySelectorAll("[data-ab-panel]");
    var overlay = root.querySelector("[data-ab-overlay]");
    var closeButtons = root.querySelectorAll("[data-ab-close]");
    var closeTimer = null;

    function isDesktop() {
      return window.matchMedia("(min-width: 769px)").matches;
    }

    function cancelClose() {
      if (closeTimer !== null) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function closeMenu() {
      cancelClose();

      triggers.forEach(function (trigger) {
        trigger.setAttribute("aria-expanded", "false");
      });

      panels.forEach(function (panel) {
        panel.hidden = true;
      });

      if (overlay) {
        overlay.hidden = true;
      }

      document.body.classList.remove("ab-menu-is-open");
    }

    function scheduleClose() {
      cancelClose();

      closeTimer = window.setTimeout(function () {
        closeMenu();
      }, 240);
    }

    function openMenu(name, trigger) {
      cancelClose();

      var selectedPanel = root.querySelector(
        '[data-ab-panel="' + name + '"]'
      );

      if (!selectedPanel) {
        return;
      }

      triggers.forEach(function (item) {
        item.setAttribute("aria-expanded", "false");
      });

      panels.forEach(function (panel) {
        panel.hidden = true;
      });

      trigger.setAttribute("aria-expanded", "true");
      selectedPanel.hidden = false;

      if (overlay) {
        overlay.hidden = false;
      }

      document.body.classList.add("ab-menu-is-open");
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener("mouseenter", function () {
        if (isDesktop()) {
          openMenu(trigger.dataset.abTarget, trigger);
        }
      });

      trigger.addEventListener("mouseleave", function () {
        if (isDesktop()) {
          scheduleClose();
        }
      });

      trigger.addEventListener("focus", function () {
        if (isDesktop()) {
          openMenu(trigger.dataset.abTarget, trigger);
        }
      });

      trigger.addEventListener("click", function () {
        var expanded =
          trigger.getAttribute("aria-expanded") === "true";

        if (expanded) {
          closeMenu();
        } else {
          openMenu(trigger.dataset.abTarget, trigger);
        }
      });
    });

    panels.forEach(function (panel) {
      panel.addEventListener("mouseenter", function () {
        cancelClose();
      });

      panel.addEventListener("mouseleave", function () {
        if (isDesktop()) {
          scheduleClose();
        }
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener("click", closeMenu);
    });

    if (overlay) {
      overlay.addEventListener("click", closeMenu);
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeMenu();
      }
    });

    window.addEventListener("resize", function () {
      if (!isDesktop()) {
        closeMenu();
      }
    });
  }

  function initAllMenus() {
    document
      .querySelectorAll("[data-ab-menu]")
      .forEach(initMenu);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initAllMenus,
      { once: true }
    );
  } else {
    initAllMenus();
  }

  document.addEventListener(
    "shopify:section:load",
    initAllMenus
  );
})();